import { useState } from "react";
import posthog from "posthog-js";
import { FaChevronDown, FaListUl, FaRegClock, FaLock, FaSeedling } from "react-icons/fa";

const TILES = [
  { Icon: FaListUl, q: "Isn't this just a list of episodes?", a: "No. Every episode comes with insights to actually try, not just something to nod along to." },
  { Icon: FaRegClock, q: "What am I actually supposed to do here?", a: "Listen, then pick a time and place to try the ideas that make sense." },
  { Icon: FaLock, q: "Do I have to share my thoughts publicly?", a: "No, but you can if you want to get feedback on your efforts. Plenty of people use this entirely on their own." },
  { Icon: FaSeedling, q: "Is this actually going to help, or is it more stuff to get through?", a: "Not more to do, a way to actually use what you already listen to." },
];

const storageKey = (guid) => `podsy-new-here-collapsed-${guid}`;

const readCollapsed = (guid) => {
  try { return localStorage.getItem(storageKey(guid)) === "1"; } catch { return false; }
};

/**
 * Collapsible (never dismissible) onboarding card. Starts open only while the
 * listener has not engaged with anything in the club (server `hasEngaged`).
 */
const NewHereSection = ({ clubGuid, hasEngaged }) => {
  const [collapsed, setCollapsed] = useState(() => hasEngaged || readCollapsed(clubGuid));

  const collapse = () => {
    setCollapsed(true);
    try { localStorage.setItem(storageKey(clubGuid), "1"); } catch { /* ignore */ }
    posthog.capture("new_here_collapsed", { club_guid: clubGuid });
  };

  const expand = () => {
    setCollapsed(false);
    try { localStorage.removeItem(storageKey(clubGuid)); } catch { /* ignore */ }
    posthog.capture("new_here_expanded", { club_guid: clubGuid });
  };

  if (collapsed) {
    return (
      <button type="button" className="lpc-newhere-bar" onClick={expand}
        aria-expanded="false" aria-controls="lpc-newhere">
        <span>New here? <strong>Learn by Doing.</strong></span>
        <FaChevronDown aria-hidden="true" />
      </button>
    );
  }

  return (
    <section className="lpc-newhere" id="lpc-newhere">
      <button type="button" className="lpc-newhere__close" onClick={collapse}
        aria-label="Collapse" aria-expanded="true" aria-controls="lpc-newhere">
        &times;
      </button>
      <p className="lpc-newhere__eyebrow">New here?</p>
      <h2 className="lpc-newhere__headline">Learn by Doing.</h2>
      <p className="lpc-newhere__sub">
        You've probably had a podcast give you a great idea that lasted about as long as the
        commute home. That's what learning by doing means: a Podcast Club is how you make
        those ideas stick.
      </p>
      <div className="lpc-newhere__grid">
        {TILES.map(({ Icon, q, a }) => (
          <div className="lpc-tile" key={q}>
            <span className="lpc-tile__icon"><Icon aria-hidden="true" /></span>
            <div>
              <p className="lpc-tile__q">{q}</p>
              <p className="lpc-tile__a">{a}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default NewHereSection;
